import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import { Workbook } from 'exceljs';
@Injectable({
  providedIn: 'root'
})
export class ExcelService {

  constructor() { }

  exportAttendanceExcel(excelData,sheetName='Sheet'): void { // plz check tsconfig.json and make sure to import

    // Title, Header & Data
    const title = excelData.title;
    const header = excelData.headers;
    const data = excelData.data;
    // Create a workbook with a worksheet
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(sheetName);
    // Add Row and formatting
    // worksheet.mergeCells('C1', 'F4');
    // const titleRow = worksheet.getCell('C1');
    // titleRow.value = title;
    // titleRow.font = {
    //   name: 'Calibri',
    //   size: 16,
    //   underline: 'single',
    //   bold: true,
    //   color: { argb: '0085A3' }
    // };
    // titleRow.alignment = { vertical: 'middle', horizontal: 'center' };

    // Blank Row
    // worksheet.addRow([]);
    // Adding Header Row
    const headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '2a295c' },
        bgColor: { argb: '' },
      };
      cell.font = {
        bold: true,
        color: { argb: 'ffffff' },
        size: 12,
      };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });

    // Adding Data with Conditional Formatting
    data.forEach(d=> {
      const row = worksheet.addRow(d);

      // const sales = row.getCell(1);
      // let color = '2af778';
      // if (sales.value === '') {
      //   color = 'FF9999';
      // }

      // sales.fill = {
      //   type: 'pattern',
      //   pattern: 'solid',
      //   fgColor: { argb: color }
      // };
      // row.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }

    }
    );

    worksheet.getColumn(1).width = 20;
    worksheet.getColumn(2).width = 30;
    worksheet.getColumn(3).width = 40;
    worksheet.getColumn(4).width = 10;

    worksheet.addRow([]);
    // Generate & Save Excel File
    // tslint:disable-next-line: no-shadowed-variable
    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      FileSaver.saveAs(blob, title + '.xlsx');
    });

  }

  attendExcelRead(event): void {

  }

  exportTrainingAttendanceExcel(excelData): void { // plz check tsconfig.json and make sure to import

    // Title, Header & Data
    const title = excelData.title;
    const header = excelData.headers;
    const data = excelData.data;
    // Create a workbook with a worksheet
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Training Attendance');
    // Add Row and formatting
    // worksheet.mergeCells('C1', 'F4');
    // const titleRow = worksheet.getCell('C1');
    // titleRow.value = title;
    // titleRow.font = {
    //   name: 'Calibri',
    //   size: 16,
    //   underline: 'single',
    //   bold: true,
    //   color: { argb: '0085A3' }
    // };
    // titleRow.alignment = { vertical: 'middle', horizontal: 'center' };

    // Blank Row
    // worksheet.addRow([]);
    // Adding Header Row
    const headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '2a295c' },
        bgColor: { argb: '' },
      };
      cell.font = {
        bold: true,
        color: { argb: 'ffffff' },
        size: 12,
      };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });

    // Adding Data with Conditional Formatting
    data.forEach(d=> {
      const row = worksheet.addRow(d);

      // const sales = row.getCell(1);
      // let color = '2af778';
      // if (sales.value === '') {
      //   color = 'FF9999';
      // }

      // sales.fill = {
      //   type: 'pattern',
      //   pattern: 'solid',
      //   fgColor: { argb: color }
      // };
      // row.eachCell((cl) => {
      //   cl.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      // });

    }
    );

    worksheet.addRow([]);
    // Generate & Save Excel File
    // tslint:disable-next-line: no-shadowed-variable
    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      FileSaver.saveAs(blob, title + '.xlsx');
    });

  }

  exportKudosDump(excelData): void { // plz check tsconfig.json and make sure to import

    // Title, Header & Data
    const title = excelData.title;
    const header = excelData.headers;
    const data = excelData.data;
    // Create a workbook with a worksheet
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(excelData.title);
    const headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '2a295c' },
        bgColor: { argb: '' },
      };
      cell.font = {
        bold: true,
        color: { argb: 'ffffff' },
        size: 12,
      };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });

    // Adding Data with Conditional Formatting
    data.forEach(d=> {
      const row = worksheet.addRow(d);

      // row.eachCell((cl) => {
      //   cl.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      // });

    }
    );

    worksheet.addRow([]);
    // Generate & Save Excel File
    // tslint:disable-next-line: no-shadowed-variable
    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      FileSaver.saveAs(blob, title + '.xlsx');
    });

  }


  excelExportMobileExpense(excelData): void { // plz check tsconfig.json and make sure to import

    // Title, Header & Data
    const title = excelData.title;
    const header = excelData.headers;
    const data = excelData.data;
    // Create a workbook with a worksheet
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Mobile Expense');
    // Add Row and formatting
    // worksheet.mergeCells('C1', 'F4');
    // const titleRow = worksheet.getCell('C1');
    // titleRow.value = title;
    // titleRow.font = {
    //   name: 'Calibri',
    //   size: 16,
    //   underline: 'single',
    //   bold: true,
    //   color: { argb: '0085A3' }
    // };
    // titleRow.alignment = { vertical: 'middle', horizontal: 'center' };

    // Blank Row
    // worksheet.addRow([]);
    // Adding Header Row
    const headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell) => {

      // console.log('cell', cell.value);
      if(cell.value!=''){
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '2a295c' },
            bgColor: { argb: '' },
          };
          cell.font = {
            bold: true,
            color: { argb: 'ffffff' },
            size: 12,
          };
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      }
    });
    // worksheet.mergeCells('G1:H1');
    // worksheet.getCell('G1').fill = {
    //   type: 'pattern',
    //   pattern: 'solid',
    //   fgColor: { argb: 'FF0000' },
    //   bgColor: { argb: '' },
    // };
    // worksheet.getCell('H1').fill = {
    //   type: 'pattern',
    //   pattern: 'solid',
    //   fgColor: { argb: 'FF0000' },
    //   bgColor: { argb: '' },
    // };



    // Adding Data with Conditional Formatting
    data.forEach(d=> {
      const row = worksheet.addRow(d);

      // const sales = row.getCell(1);
      // let color = '2af778';
      // if (sales.value === '') {
      //   color = 'FF9999';
      // }

      // sales.fill = {
      //   type: 'pattern',
      //   pattern: 'solid',
      //   fgColor: { argb: color }
      // };
      // row.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }

    });
    // worksheet.getCell('G2').fill = {
    //   type: 'pattern',
    //   pattern: 'solid',
    //   fgColor: { argb: '2a295c' },
    //   bgColor: { argb: '' },
    // };
    // worksheet.getCell('G2').font = {
    //   bold: true,
    //   color: { argb: 'ffffff' },
    //   size: 12,
    // };
    // worksheet.getCell('H2').fill = {
    //   type: 'pattern',
    //   pattern: 'solid',
    //   fgColor: { argb: '2a295c' },
    //   bgColor: { argb: '' },
    // };
    // worksheet.getCell('H2').font = {
    //   bold: true,
    //   color: { argb: 'ffffff' },
    //   size: 12,
    // };

    worksheet.getColumn(1).width = 20;
    worksheet.getColumn(2).width = 30;
    worksheet.getColumn(3).width = 40;
    worksheet.getColumn(4).width = 10;

    worksheet.addRow([]);
    // Generate & Save Excel File
    // tslint:disable-next-line: no-shadowed-variable
    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      FileSaver.saveAs(blob, title + '.xlsx');
    });

  }

  excelExportRenewalLetter(excelData): void { // plz check tsconfig.json and make sure to import

    // Title, Header & Data
    const title = excelData.title;
    const header = excelData.headers;
    const data = excelData.data;
    // Create a workbook with a worksheet
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Renewal Letter');
    // Add Row and formatting
    // worksheet.mergeCells('C1', 'F4');
    // const titleRow = worksheet.getCell('C1');
    // titleRow.value = title;
    // titleRow.font = {
    //   name: 'Calibri',
    //   size: 16,
    //   underline: 'single',
    //   bold: true,
    //   color: { argb: '0085A3' }
    // };
    // titleRow.alignment = { vertical: 'middle', horizontal: 'center' };

    // Blank Row
    // worksheet.addRow([]);
    // Adding Header Row
    const headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell) => {

      // console.log('cell', cell.value);
      if(cell.value!=''){
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '2a295c' },
            bgColor: { argb: '' },
          };
          cell.font = {
            bold: true,
            color: { argb: 'ffffff' },
            size: 12,
          };
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      }
    });
    // worksheet.mergeCells('G1:H1');
    // worksheet.getCell('G1').fill = {
    //   type: 'pattern',
    //   pattern: 'solid',
    //   fgColor: { argb: 'FF0000' },
    //   bgColor: { argb: '' },
    // };
    // worksheet.getCell('H1').fill = {
    //   type: 'pattern',
    //   pattern: 'solid',
    //   fgColor: { argb: 'FF0000' },
    //   bgColor: { argb: '' },
    // };



    // Adding Data with Conditional Formatting
    data.forEach(d=> {
      const row = worksheet.addRow(d);

      // const sales = row.getCell(1);
      // let color = '2af778';
      // if (sales.value === '') {
      //   color = 'FF9999';
      // }

      // sales.fill = {
      //   type: 'pattern',
      //   pattern: 'solid',
      //   fgColor: { argb: color }
      // };
      // row.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }

    });
    // worksheet.getCell('G2').fill = {
    //   type: 'pattern',
    //   pattern: 'solid',
    //   fgColor: { argb: '2a295c' },
    //   bgColor: { argb: '' },
    // };
    // worksheet.getCell('G2').font = {
    //   bold: true,
    //   color: { argb: 'ffffff' },
    //   size: 12,
    // };
    // worksheet.getCell('H2').fill = {
    //   type: 'pattern',
    //   pattern: 'solid',
    //   fgColor: { argb: '2a295c' },
    //   bgColor: { argb: '' },
    // };
    // worksheet.getCell('H2').font = {
    //   bold: true,
    //   color: { argb: 'ffffff' },
    //   size: 12,
    // };

    worksheet.getColumn(1).width = 20;
    worksheet.getColumn(2).width = 30;
    worksheet.getColumn(3).width = 40;
    worksheet.getColumn(4).width = 10;

    worksheet.addRow([]);
    // Generate & Save Excel File
    // tslint:disable-next-line: no-shadowed-variable
    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      FileSaver.saveAs(blob, title + '.xlsx');
    });

  }

  excelExportOngcPass(excelData): void { // plz check tsconfig.json and make sure to import

    // Title, Header & Data
    const title = excelData.title;
    const header = excelData.headers;
    const data = excelData.data;
    // Create a workbook with a worksheet
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Ongc Pass Number');
    
    const headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell) => {

      if(cell.value!=''){
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '2a295c' },
            bgColor: { argb: '' },
          };
          cell.font = {
            bold: true,
            color: { argb: 'ffffff' },
            size: 12,
          };
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      }
    });

    // Adding Data with Conditional Formatting
    data.forEach(d=> {
      const row = worksheet.addRow(d);
    });

    worksheet.getColumn(1).width = 20;
    worksheet.getColumn(2).width = 30;
    worksheet.getColumn(3).width = 40;
    worksheet.getColumn(4).width = 10;

    worksheet.addRow([]);
    // Generate & Save Excel File
    // tslint:disable-next-line: no-shadowed-variable
    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      FileSaver.saveAs(blob, title + '.xlsx');
    });

  }


  exportShiftExcel(excelData,sheetName='Sheet'): void { 

    // Title, Header & Data
    const title = excelData.title;
    const header = excelData.headers;
    const data = excelData.data;
    // Create a workbook with a worksheet
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(sheetName);

    const headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '2a295c' },
        bgColor: { argb: '' },
      };
      cell.font = {
        bold: true,
        color: { argb: 'ffffff' },
        size: 12,
      };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });

    // Adding Data with Conditional Formatting
    data.forEach(d=> {
      const row = worksheet.addRow(d);

    }
    );

    worksheet.getColumn(1).width = 20;
    worksheet.getColumn(2).width = 30;
    worksheet.getColumn(3).width = 40;
    worksheet.getColumn(4).width = 10;

    worksheet.addRow([]);
    // Generate & Save Excel File
    // tslint:disable-next-line: no-shadowed-variable
    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      FileSaver.saveAs(blob, title + '.xlsx');
    });

  }

}
